import { useEffect, useState } from 'react';
import { apiClient } from '../../utils/apiClient';
import type { KioskAlertSummary } from './types';

export const KIOSK_ALERT_SUMMARY_POLL_MS = 60000;

export const KIOSK_ALERTS_CHANGED_EVENT = 'kiosk-alerts:changed';

export function announceKioskAlertsChanged(): void {
  window.dispatchEvent(new Event(KIOSK_ALERTS_CHANGED_EVENT));
}

export function useKioskAlertSummary(enabled: boolean): KioskAlertSummary | null {
  const [summary, setSummary] = useState<KioskAlertSummary | null>(null);
  useEffect(() => {
    if (!enabled) {
      setSummary(null);
      return undefined;
    }
    let active = true;
    const load = () => {
      apiClient
        .get<{ data: KioskAlertSummary }>('/api/backend/kiosk-alerts/summary')
        .then((response) => {
          if (active) setSummary(response.data);
        })
        .catch((error) => console.error('[Kiosk alerts] the open alert count could not be loaded', error));
    };
    load();
    const timer = window.setInterval(load, KIOSK_ALERT_SUMMARY_POLL_MS);
    window.addEventListener(KIOSK_ALERTS_CHANGED_EVENT, load);
    return () => {
      active = false;
      window.clearInterval(timer);
      window.removeEventListener(KIOSK_ALERTS_CHANGED_EVENT, load);
    };
  }, [enabled]);
  return summary;
}
